// dashboard-state.service.ts
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DashboardStateService {
  private memoryStore: { [key: string]: any } = {};

  setSearchState(key: string, value: any) {
    this.memoryStore[key] = value;
  }

  getSearchState(key: string): any {
    return this.memoryStore[key] ?? null;
  }

  clearSearchState(key: string) {
    delete this.memoryStore[key];
  }
}
